exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app[data-v-d8f7ff2e]{background-color:#eff3f6}.app .wait-list[data-v-d8f7ff2e]{margin:.3rem 0;background-color:#fff}.app .wait-list li[data-v-d8f7ff2e]{height:2rem;line-height:2rem;display:flex;justify-content:space-between;padding:0 .85rem;border-bottom:.05rem solid #f0f1f5}.app .wait-list li[data-v-d8f7ff2e]:last-child{border:none}.app .wait-list li .left[data-v-d8f7ff2e]{color:#a2a2a2}.app .wait-list li .right .green[data-v-d8f7ff2e]{color:#57d3ba}.app .wait-list li .right .gray[data-v-d8f7ff2e]{color:gray}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d8f7ff2e","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/waitDoctor/WaitDoctor.vue
// module id = 488
// module chunks = 0